import Box from '@mui/material/Box/Box';
import React from 'react';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return <div role='tabpanel' hidden={value !== index} id={`custom-tab-${index}`} aria-labelledby={`custom-tab-${index}`} {...other} data-sentry-component="TabPanel" data-sentry-source-file="TabPanel.tsx">
      {value === index && <Box sx={{
      py: {
        xs: 'var(--spacing_m)',
        md: 'var(--spacing_m_nudge)'
      }
    }}>
          {children}
        </Box>}
    </div>;
}
export default TabPanel;